<div class="email-invite-container">
  <img src="/assets/images/time-out.png" alt="timeout" />
  <div class="invite-alert">{{ title }}</div>
  <div class="invite-description">
    {{ description }}
    <div *ngIf="unregisteredIp" class="invite-description">{{ secondaryDescription }}</div>
  </div>
  <div class="invite-description" *ngIf="phoneIdRedirect">
    (In case your Samsung account does not have Email ID, please register your email
    <a class="redirectSA" (click)="redirectSamsungAccount()">here</a> and sign in again)
  </div>
  <div class="button-contain" *ngIf="notFoundPage || phoneIdRedirect">
    <a *ngIf="!userInfo" class="login-btn" href="{{ loginLink }}">
      <sdc-design-button
        *ngIf="notFoundPage"
        [title]="'Sign in'"
        type="primary"
        width="220px"
        height="40px"
      ></sdc-design-button>

      <sdc-design-button
        *ngIf="phoneIdRedirect"
        [title]="'Sign back in'"
        type="primary"
        width="220px"
        height="40px"
      ></sdc-design-button>
    </a>
    <a *ngIf="userInfo" class="login-btn" (click)="goBack()">
      <sdc-design-button [title]="'Go back'" type="primary" width="220px" height="40px"></sdc-design-button>
    </a>
  </div>
</div>
